import React from 'react';
import Header from '../../components/common/global-top-bar';
import SwitchBar from '../../components/switch-bar';
import Spinner from '../../components/common/spinner';
import { PERSONA_DETAIL_TABS } from './persona-constants';
import { usePersona } from '../../hooks/usePersonaAdmin';

export type PersonaTabKey = 'overview' | 'clients' | 'rules' | 'evals' | 'prompts' | 'chat';

const TAB_INDEX: Record<PersonaTabKey, number> = {
  overview: 0,
  clients: 1,
  rules: 2,
  evals: 3,
  prompts: 4,
  chat: 5,
};

type Props = {
  personaId: string;
  tab: PersonaTabKey;
  children: React.ReactNode;
};

const PersonaShell: React.FC<Props> = ({ personaId, tab, children }) => {
  const { data: persona, isLoading } = usePersona(personaId);
  const tabs = PERSONA_DETAIL_TABS(personaId);

  const heading = persona ? `${persona.display_name || persona.name} · Persona ${persona.id}` : `Persona ${personaId}`;

  return (
    <div>
      <Header heading={heading} />
      <SwitchBar heading={tabs} position={TAB_INDEX[tab]} />
      {isLoading && !persona ? (
        <Spinner alignmentClass="flex items-center justify-center py-16" />
      ) : (
        <div>{children}</div>
      )}
    </div>
  );
};

export default PersonaShell;
